












































import { defineComponent, type PropType } from "vue-demi";
import { createPopper, type Instance } from "@popperjs/core";
import hoverintent from "hoverintent";
import type { SectionMeta } from "../../../type/SectionMeta";

export default defineComponent({
  name: "BonusCount",
  props: {
    count: {
      type: Number as PropType<number>,
      required: true,
    },
    plus: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    size: {
      type: String as PropType<"small" | "regular">,
      default: "small",
    },
    meta: {
      type: Object as PropType<SectionMeta>,
      default: () => ({}),
    },
  },
  emits: {
    "auth-needed": () => true,
  },
  data(): {
    timer: number | null;
    instance: Instance | null;
    hoverIntent: HoverIntent | null;
    isActive: boolean;
  } {
    return {
      timer: null,
      instance: null,
      hoverIntent: null,
      isActive: false,
    };
  },
  mounted() {
    this.hoverIntent = hoverintent(
      this.$refs.handler as Element,
      this.enable,
      () => null
    );
  },
  destroyed() {
    this.destroy();
    if (this.hoverIntent) this.hoverIntent.remove();
  },
  methods: {
    init() {
      if (!this.instance) {
        if (!this.$refs.handler || !this.$refs.content) {
          throw Error("Refы не найдены для BonusCount компонента");
        }

        this.instance = createPopper(
          this.$refs.handler as Element,
          this.$refs.content as HTMLElement,
          {
            placement: "top",
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, 5],
                },
              },
              {
                name: "preventOverflow",
                options: {
                  padding: 10,
                },
              },
            ],
          }
        );
      }
    },
    destroy() {
      if (this.instance) {
        this.instance.destroy();
        this.instance = null;
      }
    },
    enable() {
      this.init();
      this.isActive = true;
    },
    disable() {
      this.destroy();
      this.isActive = false;
      this.timer = null;
    },
    onMouseEnter() {
      if (!this.isActive) {
        this.isActive = true;
      }

      if (this.timer) {
        window.clearTimeout(this.timer);
        this.timer = null;
      }
    },
    onMouseLeave() {
      if (this.isActive && !this.timer) {
        this.timer = window.setTimeout(() => {
          this.disable();
        }, 500);
      }
    },
  },
});
